import React, { Component } from 'react';
import Utility from '../../../Utility';
import Browser from '../../../Browser'
import { connect } from 'react-redux';

import './Seekbar.css';

// const _ = require('lodash');

class Seekbar extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sliderValue: 0,
			scrubbing: false,
			hovering: false,
			hoverX: 0,
			hoverY: 0,
			shrinkSeekBarTID: null,
			hoverTimePos: 0,
			hovertimeOpacity: 0,
			hoverTime: 0
		};

		this.seekbarRef = React.createRef();
		this.hoverTimeRef = React.createRef();

		this.mouseDown = false;
	}

	componentDidMount() {
		window.addEventListener('mousemove', this.mousemoveHandler);
		window.addEventListener('mouseup', this.mouseupHandler);
    	document.addEventListener('player.showtimecode', this.showtimecodeHandler);
    	document.addEventListener('player.hidetimecode', this.hidetimecodeHandler);
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.mousemoveHandler);
		window.removeEventListener('mouseup', this.mouseupHandler);
    	document.removeEventListener('player.showtimecode', this.showtimecodeHandler);
		document.removeEventListener('player.hidetimecode', this.hidetimecodeHandler);
	}

	showtimecodeHandler = (ev) => {
		let time = ev.detail;

		this.setState({ hoverTime: Utility.sec2hms(time) });

		if (this.hoverTimeRef.current && this.hoverTimeRef.current.offsetWidth) {
			let seekbarWidth = this.seekbarRef.current.offsetWidth;
			let hoverTimeWidth = this.hoverTimeRef.current.offsetWidth;

			let percent = this.props.data.duration / seekbarWidth;

			let x = Math.round(time / percent);

			let pos = Math.max(8, x - (hoverTimeWidth / 2));

			if (pos > 20) {
				pos = Math.min(seekbarWidth - hoverTimeWidth - 8, x - (hoverTimeWidth / 2));
			}

			this.setState({ hoverTimePos: pos, hovertimeOpacity: 1 });
		}
	}

	hidetimecodeHandler = () => {
		this.setState({ hovertimeOpacity: 0 });
	}

	seek(time) {
		this.props.seekHandler(time);
		Utility.emit('player.controls.seek');
	}

	calcNewTime = (ev) => {
		let x = ev.clientX;
		let width = this.seekbarRef.current.offsetWidth;
		let p = x / width;
		let time = Math.round((p * this.props.data.duration) * 10)/10;
		this.seek(time);
	}

	mousedownHandler = (ev) => {
		this.mouseDown = true;

		if (this.state.shrinkSeekBarTID) {
			clearTimeout(this.state.shrinkSeekBarTID);
		}

		this.setState({
			scrubbing: true,
			hovering: true,
			shrinkSeekBarTID: null
		});

		this.calcNewTime(ev);
	}

	mouseMove2Handler = (ev) => {
		// x = position of mouse relative to scrubber (so essentially relative to page)
		let x = Utility.getPageX(ev);

		let seekbarWidth = this.seekbarRef.current.offsetWidth;

		let percent = x / seekbarWidth;

		let time = Math.round((percent * this.props.data.duration) * 10)/10

		if (time > 0) {
			this.setState({ hoverTime: Utility.sec2hms(time) });

			let hoverTimeWidth = this.hoverTimeRef.current.offsetWidth;

			let pos = Math.max(8, x - (hoverTimeWidth / 2));

			if (pos > 20) {
				pos = Math.min(seekbarWidth - hoverTimeWidth - 8, x - (hoverTimeWidth / 2));
			}

			this.setState({ hoverTimePos: pos, hovertimeOpacity: 1 });
		}
	}

	mousemoveHandler = (ev) => {
		if (this.mouseDown === true && this.state.scrubbing === true) {
			this.calcNewTime(ev);
		}
	}

	mouseupHandler = (ev) => {
		if (this.mouseDown === true) {
			this.mouseDown = false;

			this.setState({
				scrubbing: false,
				hovering: false
			});

			this.calcNewTime(ev);
		}
	}

	touchendHandler = (ev) => {
		let shrinkSeekBarTID = Utility.delay(3500, () => {
			this.setState({
				scrubbing: false,
				hovering: false
			});
		}, this);

		this.setState({
			shrinkSeekBarTID: shrinkSeekBarTID
		});

			// @hidetimeTID = util.delay 2500, =>
			//   $('#hover-time').css
			//     opacity: 0

		this.setState({
			scrubbing: false
		});
		// if ev.originalEvent.touches?.length == 0
		//   return
		this.calcNewTime(ev);
	}

	render () {
		let thumbCss = {};
		let progressBarCss = {};
		let bufferBarCss = {};

		if (this.seekbarRef.current) {
			let width = this.seekbarRef.current.offsetWidth;
			let currentTime = this.props.dynamic.currentTime;
			let duration = this.props.data.duration;

			let thumbRadius = 12 / 2;

			let p = Math.ceil(currentTime) / Math.ceil(duration);
			let barWidth = p * width;

			if (barWidth < thumbRadius) {
				barWidth = thumbRadius;
			}

			if (barWidth + thumbRadius > width) {
				thumbCss.left = (width - 2*thumbRadius) + 'px';
			} else {
				thumbCss.left = (barWidth - thumbRadius) + 'px';
			}

			progressBarCss.width = barWidth + 'px';

			let startPct = this.props.dynamic.startBuffer / duration;
			let endPct = this.props.dynamic.endBuffer / duration;
			let bufferBarWidth = (endPct - startPct)*100;

			bufferBarCss = {
				left: startPct + '%',
				width: bufferBarWidth + '%'
			};
		}

		let seekBarClasses = 'controls-seek-bar-container';

		if (this.state.scrubbing === true) {
			seekBarClasses += ' scrubbing';

			if (Browser.android() || Browser.ios()) {
				seekBarClasses += ' active';
			}
		}

		return (
			<div ref={this.seekbarRef} className={seekBarClasses} onMouseDown={this.mousedownHandler}>
				<div
					tabIndex="0"
					role="slider"
					aria-label="Seekbar"
					aria-valuemin="0"
					aria-valuemax={this.props.data.duration}
					aria-valuenow={this.props.dynamic.currentTime}
					aria-valuetext={'Current time: ' + Utility.sec2hmsLong(this.props.dynamic.currentTime)}
					className="controls-slider-track controls-seek-bar"
					onMouseOut={this.hidetimecodeHandler}
					onMouseMove={this.mouseMove2Handler}
					onMouseUp={() => {
						document.activeElement.blur();
					}}
				>
					<div className="controls-slider-bg"></div>
					<div style={thumbCss} className="controls-slider-thumb controls-progress-thumb"></div>
					<div style={progressBarCss} className="controls-slider-bar controls-progress-bar"></div>
					<div style={bufferBarCss} className="controls-buffer-bar"></div>
					<div ref={this.hoverTimeRef} style={{ left: this.state.hoverTimePos, opacity: this.state.hovertimeOpacity }} className="controls-hover-time" id="hover-time">{this.state.hoverTime}</div>
				</div>
			</div>
		)
	}
}

/*

<div class="ytp-progress-bar"
	tabindex="0"
	role="slider"
	aria-label="Seek slider"
	aria-valuemin="0"
	aria-valuemax="1305"
	aria-valuenow="184"
	aria-valuetext="3 Minutes 4 Seconds of 21 Minutes 45 Seconds"
>
	<div class="ytp-chapters-container">
		<div class="ytp-chapter-hover-container" style="width: 970px;">
			<div class="ytp-progress-bar-padding"></div>
			<div class="ytp-progress-list">
				<div class="ytp-play-progress ytp-swatch-background-color" style="left: 0px; transform: scaleX(0.141726);"></div>
				<div class="ytp-progress-linear-live-buffer"></div>
				<div class="ytp-load-progress" style="left: 0px; transform: scaleX(0.229728);"></div>
				<div class="ytp-hover-progress" style="left: 137.474px; transform: scaleX(0);"></div>
				<div class="ytp-ad-progress-list"></div>
			</div>
		</div>
	</div>
	<div class="ytp-marker-crenellation-list"></div>
	<div class="ytp-timed-markers-container"></div>
	<div class="ytp-clip-start-exclude" style="width: 0%;"></div>
	<div class="ytp-clip-end-exclude" style="left: 100%; width: 0%;"></div>
	<div class="ytp-scrubber-container" style="transform: translateX(137.474px);">
		<div class="ytp-scrubber-button ytp-swatch-background-color">
			<div class="ytp-scrubber-pull-indicator"></div>
		</div>
	</div>
</div>

*/

const mapStateToProps = (state) => ({
	dynamic: state.dynamic
});

export default connect(mapStateToProps)(Seekbar);
